import ManagerDiscoveryProvinces from './ManagerDiscoveryProvinces.container';

export default ManagerDiscoveryProvinces;
